import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import s from './Tooltip.module.scss';

export const BOTTOM = 'bottom';
export const LEFT = 'left';
export const RIGHT = 'right';
export const TOP = 'top';

export const INFO = 'info';
export const ALERT = 'alert';
export const ERROR = 'error';

const Tooltip = ({ className, style, text, arrowPosition, type, small, form, downloadButton }) => {
    if (!text) {
        return null;
    }

    return (
        <div className={classNames(s.toolTip, s[arrowPosition], s[type], className, { [s.small]: small, [s.form]: form, [s.downloadButton]: downloadButton })} style={style}>
            {text}
        </div>
    );
};

Tooltip.propTypes = {
    className: PropTypes.string,
    style: PropTypes.object,
    text: PropTypes.string,
    arrowPosition: PropTypes.oneOf([BOTTOM, LEFT, RIGHT, TOP]),
    type: PropTypes.oneOf([INFO, ALERT, ERROR]),
    small: PropTypes.bool,
    form: PropTypes.bool,
    downloadButton: PropTypes.bool,
};

Tooltip.defaultProps = {
    arrowPosition: BOTTOM,
    style: {},
    type: INFO,
    small: false,
};

export default Tooltip;
